<template>
    <page title="newCompetition" :textHeight="(WindowSize.y - 276) + 'px'">
        <template #pageContainer>
            <v-form ref="form" v-model="valid">
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						v-model="form.name"
						:label="$t('text.headerCompetitionName')+'*'"
						:error-messages="errors('name')"
						:rules="[rules.notEmpty]"
						required
						@input="$v.form.name.$touch()"
						@blur="$v.form.name.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						v-model="form.contactEmail"
						:label="$t('text.email')+'*'"
						:error-messages="errors('city')"
						:rules="[rules.notEmpty, rules.email]"
						required
						@input="$v.form.contactEmail.$touch()"
						@blur="$v.form.contactEmail.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						v-model="form.city"
						:label="$t('text.headerTown')+'*'"
						:error-messages="errors('city')"
						:rules="[rules.notEmpty]"
						required
						@input="$v.form.city.$touch()"
						@blur="$v.form.city.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						class="mt-0 pt-0"
						v-model="form.country"
						:label="$t('text.country')+'*'"
						:error-messages="errors('country')"
						:rules="[rules.notEmpty]"
						required
						@input="$v.form.country.$touch()"
						@blur="$v.form.country.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
				<v-menu
					v-model="menuEventDate"
					:close-on-content-click="false"
					max-width="290">
					<template #activator="{ on }">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							:value="formattedDate(form.eventDate)"
							:label="$t('text.date')+'*'"
							:error-messages="errors('startDate')"
							:rules="[rules.notEmpty]"
							required
							readonly
							v-on="on"
							@input="$v.form.eventDate.$touch()"
							@blur="$v.form.eventDate.$touch()"
							@click:clear="eventDate = null">
						</v-text-field>
					</template>
					<v-date-picker
						locale="DE-de"
						v-model="form.eventDate"
						@change="menuEventDate = false">
					</v-date-picker>
				</v-menu>
				</v-col></v-row>
				<v-row><v-col>


					<v-tooltip v-model="showTT" bottom>
						<template #activator="{ on }">
						<v-text-field outlined dense
							hide-details="auto"
							class="mt-0 pt-0"
							type="number"
							v-model.number="form.maxPeople"
							:label="$t('text.eventMaxPeople')+'*'"
							:error-messages="errors('maxPeople')"
							:rules="[rules.notEmpty, rules.zeroOrMore]"
							append-icon="info"
							@click:append="showToolTip()"
							required
							@input="$v.form.maxPeople.$touch()"
							@blur="$v.form.maxPeople.$touch()">
						</v-text-field>
						</template>
						<span>{{ $t('text.tootltipZeroIsinfinity') }}</span>
					</v-tooltip>


				</v-col></v-row>
            </v-form>

            <spinner :loading="loading"></spinner>
			<pop-up v-model="confirmReturn" :show="showConfirm" titel="reallySave" text="unsavedData" type="confirm" @close="callOnConfirm"></pop-up>
        </template>
		<template #pageActions>
			<v-row><v-col>

                <v-btn
                    class="mr-4"
                    :disabled="loading"
                    @click="save">
                    {{ $t(`text.save`) }}
                </v-btn>
				<!-- <v-btn
                    class="mr-4"
                    :disabled="loading"
                    @click="saveAndNext">
                    {{ $t(`text.createAndNew`) }}
                </v-btn> -->

                <v-btn
                    :disabled="loading"
                    class="mr-4"
                    @click="back">
                    {{ $t(`text.backButton`) }}
                </v-btn>
			</v-col></v-row>
        </template>
    </page>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import Page from '../../general/Page.vue';
import Spinner from '../../general/Spinner.vue';
import PopUp from '../../general/PopUp.vue';

import eventRegistration from '../../store/actions/eventRegistration';
import namespace from '../../store/namespace';

import modelState from '../../mixins/modelState';

export default {
	name: 'NewEventRegistration',
	mixins: [modelState],
	validations: {
		form: {
			name: {
				required,
			},
			contactEmail: {
				required,
			},
			city: {
				required,
			},
			country: {
				required,
			},
			eventDate: {
				required,
			},
			maxPeople: {
				required,
			},
		},
	},
	data() {
		return {
			form: {
				name: null,
				contactEmail: null,
				city: null,
				country: null,
				eventDate: null,
				maxPeople: null,
			},
			orig: {},
			menuEventDate: false,
			newEvent: {},
			showTT: false,
			showConfirm: false,
			confirmReturn: 0,
			rules: {
				notEmpty: v => (v !== null && v !== '') || this.$i18n.t('text.errorEmpty'),
				email: v => /.+@.+\..+/.test(v) || this.$i18n.t('text.errorInvalidEmail'),
				isTime: v => /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/.test(v) || this.$i18n.t('text.errorInvalidInput'),
				zeroOrMore: v => v >= 0 || this.$i18n.t('text.errorMinZero'),
			},
			routeGuard: {},
			valid: true,
			loading: false,
		};
	},
	async mounted() {
		if (this.EventRegistrationLinks.length === undefined || this.EventRegistrationLinks.length === 0) {
			await this.GET_EVENT_REG_LINKS();
		}

		if (this.isEditMode) {
			if (this.SelectedEvent === null) {
				// get Event
				const link = this.EventRegistrationLinks.find(x => x.rel === 'get_by_id');
				if (link) {
					const href = link.href
						.replace('{id}', this.eGuid);
					await this.GET_EVENT_REG_BY_ID(href);
				}
			}
			this.readFromDTO();
		} else {
			const user = await this.GET_USER_DATA();
			this.form.contactEmail = user.email;
		}
	},
	methods: {
		...mapActions(namespace.EVENTREGISTRATION, [
			eventRegistration.GET_EVENT_REG_LINKS,
			eventRegistration.NEW_EVENT_REGISTRATION,
			eventRegistration.UPDATE_EVENT_REGISTRATION,
			eventRegistration.GET_EVENT_REG_BY_ID,
			eventRegistration.GET_USER_DATA,
		]),
		showToolTip() {
			this.showTT = true;
			setTimeout(() => { this.showTT = false; }, 10000);
		},
		formattedDate(date) {
			return date
				? this.$moment(date).format('DD.MM.YYYY')
				: '';
		},
		errors(name) {
			const errors = [];
			const apiErrors = this.validateProperty(name);
			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			return errors;
		},
		async save() {
			this.$refs.form.validate();
			if (!this.$v.$invalid && this.valid) {
				this.loading = true;
				await this.create();
				this.back();
				this.loading = false;
			} else if (!this.valid && this.$refs.form.errorBag) {
				const id = Object.entries(this.$refs.form.errorBag).find(x => x[1] == true)[0];
				if (id) document.getElementById(`input-${id}`).scrollIntoView();
			}
		},
		// async saveAndNext() {
		// 	this.loading = true;
		// 	this.$refs.form.validate();
		// 	if (!this.$v.$invalid && this.valid) {
		// 		await this.create();
		// 		console.log('test');
		// 		this.resetF();
		// 	} else if (!this.valid && this.$refs.form.errorBag) {
		// 		const id = Object.entries(this.$refs.form.errorBag).find(x => x[1] == true)[0];
		// 		if (id) document.getElementById(`input-${id}`).scrollIntoView();
		// 	}
		// 	this.loading = false;
		// },
		back() {
			this.$router.go(-1);
		},
		async create() {
			this.loading = true;
			this.$v.$touch();

			if (!this.$v.$invalid && this.valid) {
				let link = null;
				let href = null;
				this.writeDTO();
				if (this.isEditMode) {
					link = this.EventRegistrationLinks.find(x => x.rel === 'update_event_reg');
					href = link.href.replace('{eventId}', this.eGuid);
				} else {
					link = this.EventRegistrationLinks.find(x => x.rel === 'new_event_reg');
				}

				if (link) {
					try {
						this.modelState = {};
						if (this.isEditMode) {
							await this.UPDATE_EVENT_REGISTRATION({ href, event: this.newEvent });
						} else {
							await this.NEW_EVENT_REGISTRATION({ link, event: this.newEvent });
						}
					} catch (e) {
						console.log(e);
						if (e.response.status === 422) {
							this.modelState = e.response.data;
							if (this.modelError()) {
								throw new Error(this.modelError());
							}
						}

						throw e;
					} finally {
						this.loading = false;
					}
				}
			}
			this.loading = false;
		},
		writeDTO() {
			this.newEvent = this.form;
			this.newEvent.ownerOrganizationId = this.Organization;
			this.orig = JSON.parse(JSON.stringify(this.form));
		},
		readFromDTO() {
			this.form = this.SelectedEvent;
			this.form.eventDate = this.$moment(this.SelectedEvent.eventDate).format('YYYY-MM-DD');
			this.form.maxPeople = this.SelectedEvent.maxPeople;
			this.orig = JSON.parse(JSON.stringify(this.form));
		},
		resetF() {
			this.$refs.form.reset();
			this.$v.$reset();
		},
		callOnConfirm() {
			this.showConfirm = false;
			if (this.confirmReturn) {
				this.routeGuard.next();
			} else {
				this.routeGuard.next(new Error('notSavedAborted'));
			}
		},
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.ORGANIZATION, ['Organization']),
		...mapGetters(namespace.USER, ['User']),
		...mapGetters(namespace.EVENTREGISTRATION, ['EventRegistrationLinks', 'SelectedEvent']),
		eGuid() {
			if (this.$route.params.eGuid) return this.$route.params.eGuid;
			return null;
		},
		isEditMode() {
			return !!this.eGuid;
		},
	},
	components: {
		Page,
		Spinner,
		PopUp,
	},
	beforeRouteLeave(to, from, next) {
		if (JSON.stringify(this.form) !== JSON.stringify(this.orig)) {
			this.routeGuard = { next };
			this.showConfirm = true;
			// next(false);
		} else {
			next();
		}
	},
};
</script>

<style lang="scss" scoped>

</style>
